import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../shared/_utils/BaseService';
import { Observable } from 'rxjs/Observable';
import { PlameType } from '../entities/plameType';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { map, tap } from 'rxjs/operators';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';

@Injectable()
export class PlameTypeService extends BaseCrudService<PlameType> {

  public uri = '/api/plameType/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PlameTypeService');
  }

  buildSentence(entity?: PlameType, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  getSequenceCode(): Observable<string> {
    const url = this.rutaServidor + this.uri + 'maxCode/';
    return this.httpClient.get<any>(url)
      .pipe(
        map(response => {
          // debugger;
          const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 2);
          const sequence = (parseInt(code, 10)) + 1;
          return FormatUtils.padLeftZero(sequence, 2);
        }),
        tap(response => {
         //console.log(response);
        })
      );
  }
}




// WEBPACK FOOTER //
// ./src/app/core/services/plame-type.service.ts